import React from 'react';

import Contact from '../../forms/Contact';
import Footer from '../../components/Footer';

import './Desktop.css';


const Component = () => (
  <div>
    <div className="contact_sec1">
      <div className="contact_mountain_circle"/>
      <div className="contact_sec1_container">
        <div className="contact_formContainer">
          <Contact />
        </div>
      </div>
    </div>

    <div className="contact_sec2">
      <div className="contact_sec2_container">
        <div className="contact_header">
          A nonprofit technology company
        </div>
        <div className="contact_body">
          As a nonprofit, Baloo aims to prove innovation can be achieved without multi-million dollar
          paychecks. With support from our members and motivation from making a positive impact, we’re
          able to create impactful technology without selling your data and inundating you with ads.
        </div>
      </div>
    </div>

    <Footer />
  </div>
);

Component.displayName = "Desktop";

export default Component;



// WEBPACK FOOTER //
// ./src/views/Contact/Desktop.js